import { render, staticRenderFns } from "./PiDetailsHeader.vue?vue&type=template&id=2feadbe0&scoped=true"
import script from "./PiDetailsHeader.vue?vue&type=script&lang=ts"
export * from "./PiDetailsHeader.vue?vue&type=script&lang=ts"
import style0 from "./PiDetailsHeader.vue?vue&type=style&index=0&id=2feadbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feadbe0",
  null
  
)

export default component.exports